import React, { Component } from 'react';
import CanvasJSReact from './assets/canvasjs.react';
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
 
class PieChart extends Component {

	componentDidMount() {
		console.log('chart', this.props.data)
	}

	render() {
		const options = {
			exportEnabled: true,
			animationEnabled: true,
			title: {
				//text: "Started Exam"
			},
			data: [{
				type: "pie",
				startAngle: 75,
				toolTipContent: "<b>{label}</b>: {y}",
				showInLegend: "false",
				legendText: "{label}",
				indexLabelFontSize: 16,
				indexLabel: "{label} : {y}",
				dataPoints: this.props.data
			}]
		}
		
		return (
		<div>
			<CanvasJSChart options = {options} 
				/* onRef={ref => this.chart = ref} */
			/>
			{/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
		</div>
		);
	}
}

export default PieChart;